import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    Typography,
    Switch,
    FormControlLabel, Card, Input, FormControl, InputLabel, Select, MenuItem, TextField
} from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import {socket} from "../../../../services/socket";
import {useDispatch} from "../../../../redux/store";
import {adminService} from "../../../../redux/system/system.request";
import {Colors} from "../../../../types";

export const System = () => {
    const navigate = useNavigate();

    const [isMaintenanceMode, setMaintenanceMode] = useState(false);
    const [isDebugWidget, setDebugWidget] = useState(false);

    const [isBackTime, setBackTime] = useState(false);
    const [isBackTimeManual, setBackTimeManual] = useState('min');
    const [isBackTimeCount, setBackTimeCount] = useState('0');

    const dispatch = useDispatch()

    useEffect(() => {

        socket.on('system_development', (data: {type: string, status: boolean}): any => {
            setMaintenanceMode(data.status)
        })

        socket.on('system_widget', (data: {type: string, status: boolean}): any => {
            setDebugWidget(data.status)
        })

        socket.on('system_backTimer', (data: {type: string, status: boolean, value: string, time: string }): any => {
            setBackTime(data.status)
            if(data.time)
            setBackTimeManual(data.time)
            if(data.value)
            setBackTimeCount(data.value)
        })

        socket.emit('get_system_status', {})

        return () => { socket.off('system_development'); socket.off('system_widget'); socket.off('system_backTimer');}

    }, [dispatch])

    const handleSwitchChange = async (switchName: string, value: boolean) => {
        if (switchName === "development") {
            setMaintenanceMode(value);
            dispatch(adminService({ type: "development", status: value }));
        } else if (switchName === "widget") {
            setDebugWidget(value);
            dispatch(adminService({ type: "widget", status: value }));
        }
    };

    const handleSwitchManual = async ( status: boolean ) => {
        dispatch(adminService({ type: "backTimer", status }));
        setBackTime(status);
    }

    const handleChangeTimeCount = async ( value: string ) => {
        dispatch(adminService({ type: "backTimer", status: isBackTime, value }));
        setBackTimeCount(value)
    }

    const handleChangeTimeManual = async ( time: string ) => {
        dispatch(adminService({ type: "backTimer", status: isBackTime, time }));
        setBackTimeManual(time)
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5">Workspace</Typography><span> /system</span>
            </Box>

            <Box sx={{ mt: 2 }}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={isMaintenanceMode}
                            onChange={(e) => handleSwitchChange("development", e.target.checked)}
                        />
                    }
                    label="Technical operation mode"
                />

                <FormControlLabel
                    control={
                        <Switch
                            checked={isDebugWidget}
                            onChange={(e) => handleSwitchChange("widget", e.target.checked)}
                        />
                    }
                    label="Enable the widget for debugging"
                />
            </Box>

            <Card sx={{ p: 2, mt: 2, width: '500px' }}>

                <Box sx={{display: 'flex', textAlign: 'center', alignItems: 'center'}}>
                    <Typography variant="subtitle1">Switch back timer</Typography>
                    <Switch
                        checked={isBackTime}
                        onChange={(e) => handleSwitchManual(e.target.checked)}
                    />
                </Box>

                <FormControl fullWidth sx={{ mt: 2 }}>
                    <TextField
                        type='number'
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={isBackTimeCount}
                        onChange={e => handleChangeTimeCount(e.target.value)}
                    />
                </FormControl>

                <FormControl fullWidth sx={{ mt: 2 }}>
                    <Select
                        labelId="time-select-label"
                        id="time-select"
                        value={isBackTimeManual}
                        onChange={(e) => handleChangeTimeManual(e.target.value)}
                    >
                        <MenuItem value="min">Minute</MenuItem>
                        <MenuItem value="hour">Hour</MenuItem>
                    </Select>
                </FormControl>
            </Card>

        </>
    );
};
